import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'camelCaseWithSpaces'
})
export class CamelCaseWithSpaces implements PipeTransform {
  transform(value: string): string | null {
    return (value) ? this.camelCaseSpacesWithFirstCase(value) : '';
  }

  private camelCaseSpacesWithFirstCase(value: string) {
    const splitValue = value.replaceAll(/([a-z])([A-Z])/g, '$1 $2').split(' ');
    return (splitValue.length > 1) ? splitValue[0] + ' ' + splitValue.slice(1).join(' ').toLowerCase() : splitValue[0];
  }
}